<template>
  <van-popup :value="true" :closeable="false" :close-on-click-overlay="false" class="popup-stampante" :class="{ 'fatture': fatturazioneElettronica }" @open="onOpen" @close="onClose" @click-overlay="onClose">
    <interfaccia :showDettaglio="showDettaglio" :infoStampante="infoStampante" :vv="visibilita" :fatture="fatturazioneElettronica" @eventi="eventiInterfaccia"/>
    <h4 class="info-center red blink" v-if="erroreAllineamento">Attenzione! I numeratori in cloud non risultano allineati! Aggiornare la pagina per riallineare.</h4>
    <stato-servizi :fatture="fatturazioneElettronica" @dettaglio="showDettaglio = !showDettaglio"/>
    <fatture-elettroniche v-if="fatturazioneElettronica"/>
  </van-popup>
</template>

<script>
/* eslint-disable */
import StatoServizi from './statoServizi'
import FattureElettroniche from './fattureElettroniche'
import stampante from '@/services/stampanteService'
import configurazioni from '@/services/configurazioniService'
import { confermaOperazione } from '@/mixins/confermaOperazione'
import { insomnia } from '@/mixins/insomnia.js'
// Verificare uso plugin per nuove stampanti !!!
import Interfaccia from './interfaccia'
import rch from './stampanti/rch'
import epson from './stampanti/epson'
import ditron from './stampanti/ditron'
import custom from './stampanti/custom'

export default {
  components: {
    StatoServizi,
    Interfaccia,
    FattureElettroniche
  },
  mixins: [confermaOperazione, insomnia],
  props: {
    context: Object
  },
  data() {
    return {
      printerStatus: null,
      infoStampante: {},
      activeName: null,
      testInterval: null,
      mostraTutto: false,
      showDettaglio: false,
      tipoDriver: 'RCH-PF', // da impostazioni
      printers: {
        'RCH-PF': rch,
        EPSON: epson,
        DITRON: ditron,
        CUSTOM: custom
      },
      richiestaStato: false,
      timerChiudi: null,
      erroreAllineamento: false,
      numeroPolling: 0,
      pollingInCorso: false,
      fatturazioneElettronica: false
    }
  },
  async mounted() {
    this.fatturazioneElettronica = !!localStorage.getItem('display_fe')
    this.testInterval = setInterval(async () => {
      await this.getInfoStampante()
      if (!this.pollingInCorso) {
        this.pollingInCorso = true
        const status = await this.getProcessStatus(this.infoStampante)
        this.$store.commit('SET_SERVICE_STATUS', status)
        this.numeroPolling++
        if (this.numeroPolling > 50) {
          console.log('Interrotto polling servizi')
          clearInterval(this.testInterval)
          this.testInterval = null
        }
        this.pollingInCorso = false
      } else {
        console.log('polling skipped')
      }
    }, 4000)
    await this.onOpen()
    this.avviaTimerChiudi()
  },
  computed: {
    visibilita() {
      return {
        mostraCambioModo: this.mostraCambioModo,
        mostraCambioStato: this.mostraCambioStato,
        mostraAggiornaOra: this.mostraAggiornaOra,
        mostraInvioPendenti: this.mostraInvioPendenti,
        classeInattiva: this.classeInattiva,
        mostraTutto: this.mostraTutto
      }
    },
    mostraCambioModo() {
      const hnd = this.printers[this.tipoDriver]
      return hnd.mostraCambioModo(this.infoStampante)
    },
    mostraCambioStato() {
      const hnd = this.printers[this.tipoDriver]
      return hnd.mostraCambioStato(this.infoStampante)
    },
    mostraAggiornaOra() {
      const hnd = this.printers[this.tipoDriver]
      return hnd.mostraAggiornaOra(this.printerStatus)
    },
    mostraInvioPendenti() {
      return false
    },
    classeInattiva() {
      return this.mostraCambioStato ? 'testo-inattiva blink' : ''
    },
    hnd() {
      return this.printers[this.tipoDriver]
    },
    statoServizi() {
      return this.$store.getters.serviceStatus
    },
    bloccaChiusura() {
      let blocca = false
      for (const s of this.statoServizi) {
        if (!s.health || s.health === '---') {
          blocca = true
        }
      }
      return blocca
    }
  },
  methods: {
    onChangeTab(name) {

    },
    async eventiInterfaccia({ tipo, payload }) {
      switch (tipo) {
        case 'aggiornaOra':
          await this.aggiornaOra()
          break
        case 'modoReg':
          this.modoReg()
          break
        case 'eseguiChiusura':
          this.eseguiChiusura()
          break
        case 'invioPendenti':
          this.invioPendenti()
          break
        case 'testStampante':
          this.testStampante()
          break
        default:
          break
      }
    },
    avviaTimerChiudi(ritardo) {
      this.timerChiudi = setInterval(() => {
        if (!this.bloccaChiusura) {
          clearInterval(this.timerChiudi)
          this.onClose()
        }
      }, ritardo || 30000)
    },
    fermaTimerChiudi() {
      clearInterval(this.timerChiudi)
    },
    async getInfoStampante() {
      if (this.context.chiusuraGiornalieraInCorso) return
      if (this.richiestaStato) return
      this.richiestaStato = true
      this.printerStatus = await stampante.printerStatus()
      //this.printerStatus = JSON.parse(JSON.stringify(this.printerStatus))
      this.richiestaStato = false
      this.tipoDriver = this.printerStatus.tipoDriver.toUpperCase() || 'RCH-PF' // per compatibilità
      // Verificare uso plugin per nuove stampanti !!!
      const hnd = this.printers[this.tipoDriver]
      this.infoStampante = hnd.infoStampante(this.printerStatus)
    },
    async onOpen() {
      await this.getInfoStampante()
      const status = await this.getProcessStatus(this.infoStampante)
      this.$store.commit('SET_SERVICE_STATUS', status)
      const verificaNumeratori = await configurazioni.verificaAllineamentoNumeratori()
      if (!['ok', '---'].includes(verificaNumeratori.status)) {
        this.erroreAllineamento = true
      }
    },
    eseguiChiusura() {
      this.fermaTimerChiudi()
      const event = {
        type: 'FUNZIONE_RAPIDA_CONFIRM',
        value: {
          funzione: 'CHIUSURA_GIORNALIERA',
          confirm: true
        }
      }
      this.$emit('send-event', event)
      this.avviaTimerChiudi(100000)
    },
    async aggiornaOra() {
      if (!this.hnd.aggiornaOraPossibile(this.printerStatus)) {
      // if (this.request.lastDocF !== '0') {
        await this.$dialog.alert({
          title: 'Aggiornamento ora stampante',
          message: 'Prima di poter aggiornare l\'ora è necessario effettuare manualmente una chiusura fiscale'
        })
        return
      }
      await stampante.setPrinterDate()
    },
    modoReg() {
      // const hnd = this.printers[this.tipoDriver]
      // hnd.passaModoReg()
      const event = {
        type: 'PRINTER',
        value: {
          // commands: ['=C1'] // PASSA_MODO_REG
          commands: ['PASSA_MODO_REG'] // PASSA_MODO_REG
        }
      }
      this.$emit('send-event', event)
    },
    invioPendenti() {

    },
    async testStampante() {
      const scontrinoInfo = [
        'Test stampante'
      ]
      await stampante.stampaScontrinoGestionale(scontrinoInfo, '')
    },
    async onClose() {
      clearInterval(this.testInterval)
      this.testInterval = null
      await this.$nextTick()
      if (!this.infoStampante.errore || this.infoStampante.errCode === 'STATUS_ERROR') {
        this.modoReg()
        setTimeout(() => { this.context.inviaBenvenutoAMF = true }, 500)
      }
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>

  .popup-stampante {
    width: 40vw;
    height: 60vh; /* 47 Attenzione lasciare spazio per pulsanti aggiornamento */
    &.fatture {
      height: 80vh;
    }
  }

  @media all and (max-width: 1800px) {
    .popup-stampante {
      width: 50vw;
      height: 67vh;
      &.fatture {
        height: 87vh;
      }
    }
  }

  @media all and (max-width: 1400px) {
    .popup-stampante {
      width: 55vw;
      height: 72vh; /* 52 Attenzione lasciare spazio per pulsanti aggiornamento */
      &.fatture {
        height: 92vh;
      }
    }
  }

  @media all and (max-width: 1024px) {
    .popup-stampante {
      width: 80vw;
      height: 72vh; /* 52 Attenzione lasciare spazio per pulsanti aggiornamento */
      &.fatture {
        height: 92vh;
      }
    }
  }

  .info-center {
    text-align: center;
    &.red {
      color: red;
    }
    &.orange {
      color: #ff8800;
    }
  }
  .testo-inattiva {
    color: red;
    font-weight: bold;
  }
  .popup-stampante .van-cell {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .blink {
    animation: blinker 1s step-start infinite;
  }

  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }
</style>
